/* tslint:disable */
/* eslint-disable */
/**
 * DaaS
 * Data as a Service - website backend for frontend.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: maritime_support@gatehouse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Registration
 */
export interface Registration {
  /**
   * The email to register an account with
   * @type {string}
   * @memberof Registration
   */
  email: string;
  /**
   * The password for the account
   * @type {string}
   * @memberof Registration
   */
  password: string;
  /**
   * The phone number of the user
   * @type {string}
   * @memberof Registration
   */
  phoneNumber?: string;
  /**
   * The first name of the account user
   * @type {string}
   * @memberof Registration
   */
  firstName?: string;
  /**
   * The last name of the account user
   * @type {string}
   * @memberof Registration
   */
  lastName?: string;
  /**
   * The name of the account user's company
   * @type {string}
   * @memberof Registration
   */
  companyName?: string;
}

/**
 * Check if a given object implements the Registration interface.
 */
export function instanceOfRegistration(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && 'email' in value;
  isInstance = isInstance && 'password' in value;

  return isInstance;
}

export function RegistrationFromJSON(json: any): Registration {
  return RegistrationFromJSONTyped(json, false);
}

export function RegistrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Registration {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json['email'],
    password: json['password'],
    phoneNumber: !exists(json, 'phone_number')
      ? undefined
      : json['phone_number'],
    firstName: !exists(json, 'first_name') ? undefined : json['first_name'],
    lastName: !exists(json, 'last_name') ? undefined : json['last_name'],
    companyName: !exists(json, 'company_name')
      ? undefined
      : json['company_name'],
  };
}

export function RegistrationToJSON(value?: Registration | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
    password: value.password,
    phone_number: value.phoneNumber,
    first_name: value.firstName,
    last_name: value.lastName,
    company_name: value.companyName,
  };
}
